import { RolesPermissions } from './role.types';

interface Roles {
  applications: {
    application: {
      name: {
        update: RolesPermissions;
      };
      permission: {
        addFromGroup: RolesPermissions;
        create: RolesPermissions;
      };
      permissions: {
        openInfoSidebar: RolesPermissions;
        list: RolesPermissions;
        menu: RolesPermissions;
      };
      webhook: {
        create: RolesPermissions;
        delete: RolesPermissions;
        update: RolesPermissions;
      };
    };
    create: RolesPermissions;
    delete: RolesPermissions;
    securityGroups: {
      update: RolesPermissions;
    };
    sharedSecretKey: {
      update: RolesPermissions;
    };
  };
  fileManager: {
    file: {
      create: RolesPermissions;
      delete: RolesPermissions;
      update: RolesPermissions;
      upload: RolesPermissions;
    };
  };
  image: {
    extractFeatures: RolesPermissions;
  };
  projects: {
    permissions: {
      list: RolesPermissions;
    };
    create: RolesPermissions;
    delete: RolesPermissions;
  };
  sidebar: {
    organizationLevel: {
      appPermissions: RolesPermissions;
      permissions: RolesPermissions;
      projects: RolesPermissions;
      team: RolesPermissions;
    };
    projectLevel: {
      applications: RolesPermissions;
      permissions: RolesPermissions;
      fileManager: RolesPermissions;
      flows: RolesPermissions;
      liveStreams: RolesPermissions;
      projectOverview: RolesPermissions;
      replications: RolesPermissions;
      jobs: RolesPermissions;
    };
  };
}

export const roles: Roles = {
  applications: {
    application: {
      name: {
        update: {
          organizationOwner: true,
          organizationAdmin: true,
          organizationViewer: false,
          projectAdmin: true,
          projectViewer: false,
        },
      },
      permission: {
        addFromGroup: {
          organizationOwner: true,
          organizationAdmin: true,
          organizationViewer: false,
          projectAdmin: false,
          projectViewer: false,
        },
        create: {
          organizationOwner: true,
          organizationAdmin: true,
          organizationViewer: false,
          projectAdmin: true,
          projectViewer: false,
        },
      },
      permissions: {
        list: {
          organizationOwner: true,
          organizationAdmin: true,
          organizationViewer: true,
          projectAdmin: false,
          projectViewer: false,
        },
        menu: {
          organizationOwner: true,
          organizationAdmin: true,
          organizationViewer: false,
          projectAdmin: true,
          projectViewer: false,
        },
        openInfoSidebar: {
          organizationOwner: true,
          organizationAdmin: true,
          organizationViewer: false,
          projectAdmin: true,
          projectViewer: false,
        },
      },
      webhook: {
        create: {
          organizationOwner: true,
          organizationAdmin: true,
          organizationViewer: false,
          projectAdmin: true,
          projectViewer: false,
        },
        delete: {
          organizationOwner: true,
          organizationAdmin: true,
          organizationViewer: false,
          projectAdmin: true,
          projectViewer: false,
        },
        update: {
          organizationOwner: true,
          organizationAdmin: true,
          organizationViewer: false,
          projectAdmin: true,
          projectViewer: false,
        },
      },
    },
    create: {
      organizationOwner: true,
      organizationAdmin: true,
      organizationViewer: false,
      projectAdmin: true,
      projectViewer: false,
    },
    delete: {
      organizationOwner: true,
      organizationAdmin: true,
      organizationViewer: false,
      projectAdmin: true,
      projectViewer: false,
    },
    securityGroups: {
      update: {
        organizationOwner: true,
        organizationAdmin: true,
        organizationViewer: false,
        projectAdmin: true,
        projectViewer: false,
      },
    },
    sharedSecretKey: {
      update: {
        organizationOwner: true,
        organizationAdmin: true,
        organizationViewer: false,
        projectAdmin: true,
        projectViewer: false,
      },
    },
  },
  fileManager: {
    file: {
      // create folder
      create: {
        organizationOwner: true,
        organizationAdmin: true,
        organizationViewer: false,
        projectAdmin: true,
        projectViewer: false,
      },
      delete: {
        organizationOwner: true,
        organizationAdmin: true,
        organizationViewer: false,
        projectAdmin: true,
        projectViewer: false,
      },
      update: {
        organizationOwner: true,
        organizationAdmin: true,
        organizationViewer: false,
        projectAdmin: true,
        projectViewer: false,
      },
      // upload file
      upload: {
        organizationOwner: true,
        organizationAdmin: true,
        organizationViewer: false,
        projectAdmin: true,
        projectViewer: false,
      },
    },
  },
  image: {
    extractFeatures: {
      organizationOwner: true,
      organizationAdmin: true,
      organizationViewer: false,
      projectAdmin: true,
      projectViewer: false,
    },
  },
  projects: {
    create: {
      organizationOwner: true,
      organizationAdmin: true,
      organizationViewer: false,
      projectAdmin: false,
      projectViewer: false,
    },
    delete: {
      organizationOwner: true,
      organizationAdmin: true,
      organizationViewer: false,
      projectAdmin: false,
      projectViewer: false,
    },
    permissions: {
      list: {
        organizationOwner: true,
        organizationAdmin: true,
        organizationViewer: true,
        projectAdmin: true,
        projectViewer: true,
      },
    },
  },
  sidebar: {
    organizationLevel: {
      appPermissions: {
        organizationOwner: true,
        organizationAdmin: true,
        organizationViewer: true,
        projectAdmin: false,
        projectViewer: false,
      },
      permissions: {
        organizationOwner: true,
        organizationAdmin: true,
        organizationViewer: true,
        projectAdmin: false,
        projectViewer: false,
      },
      projects: {
        organizationOwner: true,
        organizationAdmin: true,
        organizationViewer: true,
        projectAdmin: true,
        projectViewer: true,
      },
      team: {
        organizationOwner: true,
        organizationAdmin: true,
        organizationViewer: true,
        projectAdmin: false,
        projectViewer: false,
      },
    },
    projectLevel: {
      applications: {
        organizationOwner: true,
        organizationAdmin: true,
        organizationViewer: true,
        projectAdmin: true,
        projectViewer: true,
      },
      permissions: {
        organizationOwner: true,
        organizationAdmin: true,
        organizationViewer: true,
        projectAdmin: true,
        projectViewer: true,
      },
      fileManager: {
        organizationOwner: true,
        organizationAdmin: true,
        organizationViewer: true,
        projectAdmin: true,
        projectViewer: true,
      },
      flows: {
        organizationOwner: true,
        organizationAdmin: true,
        organizationViewer: true,
        projectAdmin: true,
        projectViewer: true,
      },
      liveStreams: {
        organizationOwner: true,
        organizationAdmin: true,
        organizationViewer: true,
        projectAdmin: true,
        projectViewer: true,
      },
      projectOverview: {
        organizationOwner: true,
        organizationAdmin: true,
        organizationViewer: true,
        projectAdmin: true,
        projectViewer: true,
      },
      replications: {
        organizationOwner: true,
        organizationAdmin: true,
        organizationViewer: true,
        projectAdmin: true,
        projectViewer: true,
      },
      jobs: {
        organizationOwner: true,
        organizationAdmin: true,
        organizationViewer: true,
        projectAdmin: true,
        projectViewer: true,
      },
    },
  },
};
